"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m15 16-4 4h10v-4zm-2.94-8.81L3 16.25V20h3.75l9.06-9.06zm1.0721-1.0674 2.5386-2.5385 3.7476 3.7476-2.5385 2.5386z"
}), 'DriveFileRenameOutlineSharp');